import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Header.css';
import logoPng from './logo.png';
import {
  getCurrentUser,
  getAccounts,
  isLoggedIn,
} from '../../selectors/authentication';
import UserHeader from './UserHeader';
import {
  switchAccount,
  clearCurrentUser,
  logoutRequest,
} from '../../actions/authentication';
import NotificationsContainer from './NotificationsContainer';

class Header extends Component {
  handleAccountClick = (acc) => {
    this.props.dispatch(switchAccount(acc));
  };

  handleAddAccount = () => {
    this.props.dispatch(clearCurrentUser());
  };

  handleLogout = () => {
    this.props.dispatch(logoutRequest());
  };

  render() {
    return (
      <header className="header">
        <img src={logoPng} className="logo" alt="Spackle Logo" />
        {this.props.isLoggedIn && (
          <div className="header-right-container">
            <NotificationsContainer />
            <UserHeader
              currentUser={this.props.currentUser}
              accounts={this.props.accounts || []}
              onAccountClick={this.handleAccountClick}
              onAddAccount={this.handleAddAccount}
              onLogout={this.handleLogout}
            />
          </div>
        )}
      </header>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    accounts: getAccounts(state),
    isLoggedIn: isLoggedIn(state),
  };
})(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.js